import { useEffect, useRef } from "react";
import type { AgentFailure } from "../modules/episodes/types";
import {
  useBillingLimit,
  type BillingLimitInfo,
} from "../modules/settings/hooks/useBillingLimit";

export const DEMO_CREDIT_DISABLED_COPY =
  "Your $1 demo agent credit has been used.";

// @tested-by: tst_fe_agent_credit_036
export function formatUsdMicros(micros: number): string {
  return `$${(micros / 1_000_000).toFixed(2)}`;
}

export function liveAgentDisabledReason(
  limit: BillingLimitInfo | undefined,
  failure: AgentFailure | null,
): string | null {
  if (failure?.kind === "credit_exhausted") {
    return DEMO_CREDIT_DISABLED_COPY;
  }
  if (
    limit?.credit_limit_micros !== null &&
    limit?.entitled === false
  ) {
    return DEMO_CREDIT_DISABLED_COPY;
  }
  return null;
}

export function useLiveAgentBilling(
  isStreaming: boolean,
  failure: AgentFailure | null,
): {
  readonly disabledReason: string | null;
  readonly limit: BillingLimitInfo | undefined;
} {
  const { limit, reload } = useBillingLimit();
  const wasStreamingRef = useRef(false);
  useEffect(() => {
    if (wasStreamingRef.current && !isStreaming) {
      reload();
    }
    wasStreamingRef.current = isStreaming;
  }, [isStreaming, reload]);
  return {
    disabledReason: liveAgentDisabledReason(limit, failure),
    limit,
  };
}
